__turbopack_context__.v({
  "dot": "PaginationDots-module-scss-module__FOSnba__dot",
  "fade-in": "PaginationDots-module-scss-module__FOSnba__fade-in",
  "isActive": "PaginationDots-module-scss-module__FOSnba__isActive",
  "pill": "PaginationDots-module-scss-module__FOSnba__pill",
  "root": "PaginationDots-module-scss-module__FOSnba__root",
});
